
import { Fraga } from "@/types/riskbedomning";

export const heightRiskFragor: Fraga[] = [
  {
    id: "fallrisk-tva-meter",
    text: "Finns det risk att falla till en lägre nivå, om nivåskillnaden är två meter eller mer?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att skyddsräcken eller andra fasta skydd saknas vid arbetsplatsen?",
      "Finns det risk för fall genom öppningar eller hål i golv?"
    ]
  }
];
